import { cn } from "../../lib/utils.js";

/** Isolate LTR values (phone, email) so RTL layout does not reorder them. */
export function LtrValue({
  children,
  className,
  title,
}: {
  children: React.ReactNode;
  className?: string;
  title?: string;
}): React.JSX.Element {
  return (
    <span dir="ltr" className={cn("[unicode-bidi:isolate]", className)} title={title}>
      {children}
    </span>
  );
}
